import { BaseDto } from '../../core';
import { EmergencyContactDto } from './emergency-contact.dto';
import { BUYER_COMPANY_STATUS, BUSINESS_TYPE, REFUSE_TYPE, QUESTION_TYPE, QUESTION_SUBTYPE, WorldCountry, CERTIFICATE_STATUS } from '../../shared';
import { VatAttachmentDto } from './vat-attachment.dto';
import { businessAttachmentDto } from './business-attachment.dto';
export class BuyerCompany extends BaseDto<BuyerCompany> {
  constructor(partial?: any) {
    super(partial);
  }
  id: number;
  name: string;

  ceoFirstName: string;

  ceoLastName: string;

  // businessType: string;
  businessType?: BUSINESS_TYPE[];

  questionType?: QUESTION_TYPE[];
  questionSubType?: QUESTION_SUBTYPE[];
  questionOther?: string;

  country:WorldCountry;
  countryCode: string;

  city: string;

  address1: string;

  address2: string;

  zipcode: string;

  callingCode: string;

  phone: string;

  registrationNumber: string | null;

  faxCallingCode: string;

  fax: string | null;

  website: string | null;

  // refuseType: string[];
  refuseType: REFUSE_TYPE[];

  refuseReason: string;
  buyerCompanyStatus: BUYER_COMPANY_STATUS;

  emergencyContact: EmergencyContactDto[];
  anniversary?: Date;
  anniversaryCount?: number;

  vatNumber?: string;
  vatAttachment: VatAttachmentDto[];
  businessNumber: string;
  businessAttachment: businessAttachmentDto[];

  certificateStatus: CERTIFICATE_STATUS;
  rejectedReason: string;
}
